import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ApiButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  HtmlTrans,
} from 'web-library';


import { makeStyles } from 'tss-react/mui';
import { MutationStatus } from 'react-query';

const useStyles = makeStyles()((theme) =>
({
  button: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

interface RemoveBlacklistedCandidateProps {
  modalState: boolean;
  onDialogConfirm: () => void;
  onDialogClose: () => void;
  candidateNames: string[];
  apiStatus: MutationStatus;
}

const RemoveBlacklistedCandidateModal = ({
  modalState,
  onDialogConfirm,
  onDialogClose,
  candidateNames,
  apiStatus,
}: RemoveBlacklistedCandidateProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={modalState} maxWidth="md">
      <DialogTitle>{t('admin->>CandidateBlacklist.RemoveCandidate')}</DialogTitle>

      <DialogContent>
        <DialogContent>
          <DialogContentText>
            <HtmlTrans
              i18nKey="admin->>CandidateBlacklist.RemoveConfirmationMsg"
              values={{
                candidateName: candidateNames.join(', '),
              }}
            />
          </DialogContentText>
        </DialogContent>
      </DialogContent>

      <DialogActions>
        <div className={classes.button}>
          <Button type="button" variant="text" onClick={() => onDialogClose()}>
            {t('admin->>CandidateBlacklist.Cancel')}
          </Button>
          <ApiButton
            type="submit"
            onClick={() => {
              onDialogConfirm();
            }}
            status={apiStatus}
          >
            {t('admin->>CandidateBlacklist.Proceed')}
          </ApiButton>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveBlacklistedCandidateModal;
